<template>
	<svg viewBox="0 0 200 110">
		<!-- Static colored arc, always fully displayed -->
		<path
			d="M 10,100 A 90,90 0 0 1 190,100"
			fill="none"
			stroke="url(#gradient)"
			stroke-width="18" />

		<!-- Needle, rotates based on the rating -->
		<g :transform="`rotate(${needleAngle}, 100, 100)`">
			<rect x="97" y="10" width="6" height="90" rx="3" ry="3" fill="#666" />
			<circle cx="100" cy="100" r="7" fill="#666" />
		</g>

		<!-- Semi-transparent rectangle behind the text -->
		<!-- <rect
			x="70"
			y="30"
			width="60"
			height="50"
			fill="white"
			fill-opacity="0.2"
			rx="5"
			ry="5" /> -->

		<!-- Text for the score, larger and bolder -->
		<!-- fill="#333" -->
		<text
			x="100"
			y="60"
			font-family="sans-serif"
			font-size="42"
			font-weight="bolder"
			fill="orange"
			text-anchor="middle"
			alignment-baseline="middle">
			{{ rating }}
		</text>

		<!-- Gradient definition for the arc -->
		<defs>
			<linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
				<stop offset="0%" stop-color="#f44336" />
				<!-- Green at 0% -->
				<stop offset="50%" stop-color="#ffeb3b" />
				<!-- Yellow at 50% -->
				<stop offset="100%" stop-color="#4caf50" />
				<!-- Red at 100% -->
			</linearGradient>
		</defs>
	</svg>
</template>

<script setup>
	import { computed } from "vue"

	const props = defineProps({
		rating: {
			type: Number,
			required: true,
			validator: (value) => value >= 0 && value <= 10,
		},
	})

	// Compute the angle of the needle based on the rating
	const needleAngle = computed(() => {
		// Rating of 0 corresponds to -90 degrees, rating of 10 corresponds to 90 degrees
		return (props.rating / 10) * 180 - 90
	})
</script>
